import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface IncentiveCampaignSpendProps extends BaseTemplateProps {
  averageDailySpend: number
  campaignLink: string
  campaignName: string
  currentDate: string
  totalSpend: number
}

export const IncentiveCampaignSpend: TemplateDefinition<IncentiveCampaignSpendProps> = {
  renderParams: (props: IncentiveCampaignSpendProps) => ({
    messageKey: 'notificationsDomain.templates.incentiveCampaignSpend',
    values: {
      averageDailySpend: props.averageDailySpend,
      campaignLink: props.campaignLink,
      campaignName: props.campaignName,
      currentDate: props.currentDate,
      totalSpend: props.totalSpend,
    },
  }),
  getLink: (props: IncentiveCampaignSpendProps): string => props.campaignLink,
}
